import { Breadcrumb } from 'antd';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import capitalize from '../utils/capitalize';






const BreadCumbNav = () => {
  const location = useLocation();
  const baseUrl = window.location.origin;

  let pathSegments = location.pathname.split('/').filter(Boolean).map((item, idx) => ({key: idx, path: item}));
  
  
  return (
    <Breadcrumb 
      items={pathSegments}
      itemRender={(currentRoute, params, routes, paths) => {
        const path = `/${routes.map(item => item.path).slice(0, currentRoute.key+ 1).join('/')}`; // Create the full path up to the current segment
        return (
          <Link to={`${baseUrl}${path}`}>{capitalize(currentRoute.path)}</Link>
        );
      }}
    />
  )
}

export default BreadCumbNav